import { render } from "./BillingStatusBadge.vue?vue&type=template&id=23e44d8c&scoped=true"
import script from "./BillingStatusBadge.vue?vue&type=script&lang=js"
export * from "./BillingStatusBadge.vue?vue&type=script&lang=js"

import "./BillingStatusBadge.vue?vue&type=style&index=0&id=23e44d8c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e44d8c"]])

export default __exports__